import React, { FC, MouseEvent, useEffect, useRef, useState } from "react";
import Tooltip from "@mui/material/Tooltip";
import { KeyboardArrowDown } from "@mui/icons-material";
import ArrowPopper from "components/app/ArrowPopper";
import { classHOC } from "components/app/ClassWrapper";
import { Account } from "types/portfolio";
import moment from "moment";

const SubRenewalDateCellRenderer: FC<{ data: Account }> = ({ data }) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLDivElement>(null);
  const popRef = useRef<HTMLDivElement>(null);
  const rootRef = useRef<HTMLDivElement>(null);
  const renewalDate = data?.subscriptions?.find((sub) => sub.status !== "Pending")?.renewalDate;

  useEffect(() => {
    document.addEventListener("click", closePop);
    return () => {
      document.removeEventListener("click", closePop);
    };
  }, []);

  const closePop = (e: Event) => {
    if (
      !popRef.current?.contains(e.target as Node) &&
      popRef.current !== e.target &&
      !rootRef.current?.contains(e.target as Node)
    ) {
      setAnchorEl(null);
    }
  };

  const handleClick = (event: MouseEvent<HTMLDivElement>) => {
    setAnchorEl(anchorEl ? null : event.currentTarget);
  };

  return (
    <>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          cursor: "pointer",
        }}
        ref={rootRef}
        onClick={handleClick}
      >
        {renewalDate ? moment(renewalDate).format("MM/DD/YYYY") : "N/A"}
        <KeyboardArrowDown style={{ fontSize: "1rem" }} />
      </div>
      {anchorEl ? (
        <ArrowPopper
          open={Boolean(anchorEl)}
          anchorEl={anchorEl}
          placement="right-start"
          disablePortal={false}
          modifiers={[{ name: "offset", options: { offset: [0, 0] } }]}
          style={{ zIndex: 2000, marginLeft: -30, minWidth: 340 }}
        >
          <div ref={popRef}>
            <div style={{ fontWeight: 700, fontSize: 15, marginBottom: 4 }}>
              Subscription Renewal Details
            </div>
            <table
              style={{
                width: "100%",
                borderCollapse: "collapse",
                fontSize: 13,
              }}
            >
              <thead>
                <tr>
                  <th style={{ textAlign: "left", padding: "4px 8px" }}>Subscription ID</th>
                  <th style={{ textAlign: "left", padding: "4px 8px" }}>Renewal Date</th>
                  <th style={{ textAlign: "left", padding: "4px 8px" }}>
                    <Tooltip
                      title={
                        <span
                          style={{
                            whiteSpace: "nowrap",
                            fontSize: 13,
                            padding: "0 8px",
                            display: "inline-block",
                          }}
                        >
                          Cloud Meetings + Messaging, Cloud Calling, Webex Contact Center
                        </span>
                      }
                      arrow
                      placement="top"
                      componentsProps={{
                        tooltip: {
                          sx: { maxWidth: "none", overflow: "visible", px: 1 },
                        },
                      }}
                    >
                      <span style={{ cursor: "pointer" }}>Cloud Invoice ARR</span>
                    </Tooltip>
                  </th>
                </tr>
                <tr>
                  <td colSpan={3}>
                    <hr
                      style={{
                        border: "none",
                        borderBottom: "1px solid #eee",
                        margin: 0,
                      }}
                    />
                  </td>
                </tr>
              </thead>
              <tbody>
                {Array.isArray(data.subscriptions) &&
                data.subscriptions.filter((sub) => sub.status !== "Pending").length > 0 ? (
                  data.subscriptions
                    .filter((sub) => sub.status !== "Pending")
                    .map((sub, idx, arrFiltered) => {
                      const arr = [
                        sub.invoiceArrCloudWXCC || 0,
                        sub.invoiceArrCloudCalling || 0,
                        sub.invoiceArrCloudMtg || 0,
                      ].reduce((a, b) => a + b, 0);
                      const isLast = idx === arrFiltered.length - 1;
                      return (
                        <React.Fragment key={sub.subscriptionId || idx}>
                          <tr>
                            <td style={{ padding: "4px 8px" }}>{sub.subscriptionId || "-"}</td>
                            <td style={{ padding: "4px 8px" }}>
                              {sub.renewalDate
                                ? moment(sub.renewalDate).format("YYYY-MM-DD")
                                : "N/A"}
                            </td>
                            <td style={{ padding: "4px 8px" }}>
                              {arr > 0 ? `$${arr.toLocaleString()}` : "-"}
                            </td>
                          </tr>
                          {!isLast && (
                            <tr>
                              <td colSpan={3}>
                                <hr
                                  style={{
                                    border: "none",
                                    borderBottom: "1px solid #eee",
                                    margin: 0,
                                  }}
                                />
                              </td>
                            </tr>
                          )}
                        </React.Fragment>
                      );
                    })
                ) : (
                  <tr>
                    <td
                      colSpan={3}
                      style={{ textAlign: "center", padding: "8px" }}
                    >
                      No subscription data
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </ArrowPopper>
      ) : null}
    </>
  );
};

export default classHOC(SubRenewalDateCellRenderer);
